import React, { useEffect, useState } from "react";

function RechargeFail() {
  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <div class="rechargeFail">
                <div class="icon">❌</div>
                <h1>Recharge Failed</h1>
                <p>Unfortunately, your recharge could not be processed at this time.</p>
                <p>Please try again or contact support if the issue persists.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RechargeFail;
